import { useMemo } from 'react';
import { CachePolicies, Provider } from 'use-http';

const HttpProvider = ({ children }) => {
    const API_URL = process.env.REACT_APP_API_URL;

    const options = useMemo(() => {
        return {
            cachePolicy: CachePolicies.NO_CACHE
        };
    }, []);

    return (
        <Provider url={API_URL} options={options}>
            {children}
        </Provider>
    );
};

export default HttpProvider;
